/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION : CONFIG CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
  configcontroller: {
    minHeight: pxToEm(80),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: replacePXinStringWithEM('0 24px'),
    '&.disabled-true': {
      '& .title': {
        extend: disable
      }
    },
    [mediaQuery.customizeThinnest]: {
      flexDirection: 'column',
      '& > *': {
        marginTop: pxToEm(16)
      },
      '& > *:last-child': {
        marginBottom: pxToEm(16)
      }
    },
    '& .button:not(:first-child)': {
      marginLeft: pxToEm(16)
    },
    '& .description': {
      opacity: '0',
      animationName: 'fadeInUp',
      animationDuration: '.1s',
      animationDelay: '.3s',
      animationFillMode: 'forwards',
    },
    '& .button': {
      height: pxToEm(32),
      width: 'auto',
      padding: replacePXinStringWithEM('0 16px'),
      '& .text': {
        fontSize: pxToEm(14),
        fontWeight: 500,
        fontFamily: '"Work Sans", sans-serif;'
      }
    }
  }

});
